<template>
  <div class="topProduct">
    <navBar></navBar>
    <div class="container">
      <div class="hotProduct-background"></div>
      <div class="hotProduct">
        <div class="hotProduct-title">{{ $t("topProduct.subTitle") }}</div>
        <span v-if="productList && productList.length > 0">
          <div
            class="hotProduct-wrapper"
            v-for="(product, index) in productList"
            @click="toDetail(product.PId)"
            :key="index"
          >
            <div class="image">
              <el-image
                :src="imgUrlFilter(product.ProductCover)"
                fit="contain"
              ></el-image>
            </div>
            <div class="name">{{ product.ProductName }}</div>
          </div>
        </span>
        <div class="list-empty" v-else>
          {{ $t("topProduct.empty") }}
        </div>
      </div>
      <menu-list
        :active="active"
        :listHotClass="hotClass"
        :listHotProducts="hotList"
        @loadMenuProduct="loadCategory"
      />
    </div>
    <basket></basket>
  </div>
</template>
<script>
import MenuList from "./components/menuList";
export default {
  name: "topProduct",
  components: {
    MenuList
  },
  data() {
    return {
      active: "1",
      BPCId: null,
      pageIndex: 1,
      pageSize: 20,
      pageCount: 1,
      productList: [],
      hotClass: [],
      hotList: {
        product: [],
        totalCount: 1
      }
    };
  },
  created() {
    const { BPCId, Active } = this.$route.query;
    if (Active === undefined || String(Active) === "1" || !BPCId) {
      this.BPCId = "";
    } else {
      this.BPCId = BPCId;
    }
    this.active = Active ? Active.toString() : "1";
    this.getTopProductAndClassInfo().then(success => {
      if (success) {
        this.getList();
      }
    });
  },
  methods: {
    sizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    currentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    getTopProductAndClassInfo() {
      return new Promise(resolve => {
        
        let param = {};
        this.$api.customer
          .getTopProductAndClassInfo(param)
          .then(res => {
            
            const data = res.data;
            this.hotClass = data.ClassList;
            this.hotClass.unshift({
              BPCId: 0,
              ClassIcon: "",
              ClassName: this.$t("topProduct.all"),
              IsDisplay: 1,
              ParentId: 0
            });
            this.productList = data.TopProductList;
            resolve(true);
          })
          .catch(error => {
            
            this.$message.error(error.message);
          });
      });
    },
    getList() {
      return new Promise(resolve => {
        
        var param = {
          PageIndex: this.pageIndex,
          PageSize: this.pageSize,
          BPCId: this.BPCId || ""
        };
        this.$api.product
          .getProductSearchList(param)
          .then(res => {
            const data = res.data;
            this.hotList.product = data;
            this.hotList.totalCount = res.meta.total;
            
            resolve(true);
          })
          .catch(err => {
            
            this.$message.error(err.message);
          });
      });
    },
    loadCategory(data) {
      this.BPCId = data.BPCId;
      this.pageIndex = data.pageIndex;
      this.pageSize = data.pageSize;
      this.getList();
    },
    toDetail(productNumber) {
      let routeUrl = this.$router.resolve({
        path: "/commodity",
        query: { ProductNumber: productNumber }
      });
      window.open(routeUrl.href, "_blank");
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    }
  }
};
</script>
<style lang="scss">
.topProduct {
  background-color: rgb(246, 246, 246);
  .container {
    width: 100%;
    padding-top: 8%;
    padding-bottom: 3%;
    position: relative;
    .hotProduct-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background-image: url("~assets/img/store/bg_1@2x.png");
      background-size: auto;
      background-position: center;
      height: 200px;
    }
    .hotProduct {
      z-index: 11;
      position: relative;
      width: 80%;
      margin-left: 10%;
      padding: 20px 30px 30px 30px;
      box-shadow: 0 0 5px 0 #9b9b9b;
      background: #fff;
      border-radius: 10px;
      .hotProduct-title {
        font-weight: bold;
      }
      .hotProduct-wrapper {
        display: inline-block;
        margin-top: 1%;
        margin-left: 3%;
        cursor: pointer;
        text-align: center;
        .image {
          vertical-align: middle;
          border-radius: 100%;
          .el-image {
            width: 50px;
            height: 50px;
            border-radius: 100%;
            border: 1px solid #e5e5e5;
            .el-image__error {
              font-size: 10px;
            }
          }
        }
        .name {
          color: #777;
          width: 100px;
          height: 18px;
          font-size: 12px;
          margin-top: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .list-empty {
        display: block;
        text-align: center;
        width: 100%;
        margin-bottom: 20px;
        margin-top: 10px;
        color: #999;
      }
    }
  }
}
</style>
